
const Survery = () => {
  return (
    <div className="py-5 lg:py-12 px-5 font-montserrat flex flex-col items-center">
      <div className="lg:w-6/12 flex flex-col gap-2">
      <h1 className="text-black font-semibold text-2xl lg:text-3xl text-center">Survey</h1>
      <p className="text-dark-gray text-sm lg:text-base font-light tracking-wider text-center mt-1">Help us understand how students and early-career professionals experience the MPISW. Responses are anonymous.</p>
      <div className="mx-auto mt-1">
       <button className="bg-black text-sm lg:text-base text-white px-10 py-3 rounded-md hover:bg-dark-gray hover:font-medium">
  <a
    href="https://usc.qualtrics.com/jfe/form/SV_3Igdvtfz9TnFPjo"
    target="_blank"
    rel="noopener noreferrer"
  >
    Take the Survey
  </a>
</button>

      </div>
      

      </div>
   
    </div>
  )
}

export default Survery
